var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loadingNavigation)?_c('div',[_c('loadingNav')],1):_vm._l((_vm.navigation),function(nav){return _c('div',{key:nav.id,staticClass:"row",on:{"click":_vm.closeMenu}},[_c('router-link',{attrs:{"to":nav.route}},[_vm._v(_vm._s(nav.name))])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }